<template>
  <div class="dialog-user-content">
    <div class="dialog-user-content-body">
      <div class="dialog-user-content-body-title">
        <h1>{{rowExamName}}</h1>
      </div>
      <div class="dialog-user-content-body-test" v-for="(item,index) in answerExamtPaperTests" :key="index">
        <div class="dialog-user-content-body-test-title">
          <span class="redismust" v-if="item.is_must == '1'" style="color: red;margin-right: 5px">*</span>
          <span>{{item.sort}}、{{item.case_problem}}</span>
        </div>
        <div class="dialog-user-content-body-test-answer-xzt" v-if="item.type == 'XZT_DXT' || item.type == 'XZT_DDXT' || item.type == 'YZT_XB' || item.type == 'YZT_NL'">
          <div v-for="(answer,indexItem) in item.choose_list" :key="indexItem">
            <span :class="item.answer && item.answer.indexOf(answer.value) > -1?'xzt-selected':''">{{answer.value}}、{{answer.text}}</span>
          </div>
        </div>
        <div class="dialog-user-content-body-test-answer-wdt" v-if="item.type == 'ZGT_WDT' || item.type == 'ZGT_HXTKT' || item.type == 'YZT_XM' || item.type == 'YZT_SJH'">
          <span>{{item.answer}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    //列表字段
    answerExamtPaperTests:{
      type:Array,
      default:function() {
        return [];
      }
    },
    rowExamName:{
      type:String,
      default:""
    }
  },
  data() {
    return {};
  },
  methods: {
  },
  created(){
  },
  computed:{
  }
};
</script>

<style lang='scss' scoped>
  ::v-deep .el-scrollbar__wrap {
    overflow: scroll-y;
    overflow-x: hidden;
    height:680px;
  }
  ::v-deep .el-card__body{
    padding: 0px 0px 0px 0px;
  }
  ::v-deep .el-card__header{
    height: 61px !important;
  }
  .xzt-selected{
    background-color: #82ff17;
  }
  .dialog-user-content {
    height: 100%;
    width: 100%;
    padding: 0px 24px !important;
    background-color: rgb(255, 255, 255);
    .dialog-user-content-body{
      display: flex;
      flex-flow: column nowrap;
      height: 100%;
      width: 100%;
      .dialog-user-content-body-title{
        font-size: 20px;
        width: 100%;
        text-align: center;
        margin-bottom: 20px;
      }
      .dialog-user-content-body-test{
        width: 100%;
        margin-bottom: 20px;
        .dialog-user-content-body-test-title{
          position: relative;
          display: flex;
          margin-bottom: 10px;
          font-size: 16px;
          .redismust{
            position: absolute;
            left: -10px;
          }
        }
        .dialog-user-content-body-test-answer-xzt{
          margin-bottom: 10px;
          margin-left: 10px;
          font-size: 16px;
        }
        .dialog-user-content-body-test-answer-wdt{
          margin-bottom: 10px;
          margin-left: 10px;
          font-size: 16px;
        }
      }
    }
  }

</style>
